import { logWarn } from '../index';
class EventBus {
    constructor() {
        this.events = new Map();
    }
    on(eventName, callback) {
        if (!eventName || !callback) {
            logWarn('Event name or callback is not provided');
        }
        else {
            if (!this.events.get(eventName)) {
                this.events.set(eventName, []);
            }
            this.events.get(eventName)?.push(callback);
        }
    }
    off(eventName, callback) {
        if (!eventName || !callback) {
            logWarn('Event name or callback is not provided');
        }
        else {
            const callbacks = this.events.get(eventName);
            if (callbacks) {
                this.events.set(eventName, callbacks.filter((cb) => cb !== callback));
            }
        }
    }
    emit(eventName, data) {
        const callbacks = this.events.get(eventName);
        callbacks?.forEach((callback) => {
            if (typeof callback === 'function') {
                callback(data);
            }
        });
    }
    of(eventName) {
        if (!eventName) {
            logWarn('Event name is not provided');
            return;
        }
        return this.events.get(eventName);
    }
    once(eventName, callback) {
        if (!eventName || !callback) {
            logWarn('Event name or callback is not provided');
        }
        else {
            const onceCallback = (data) => {
                callback(data);
                this.off(eventName, onceCallback);
            };
            this.on(eventName, onceCallback);
        }
    }
}
export default EventBus;
